import { type FC } from 'react';

import { Typography } from 'enable-ui';

import { LessonTableContainer } from 'modules/classes/styles/lesson';
import { CustomHeader } from 'modules/dashboard/components/CustomHeader';
import { LessonType, type Lessons } from 'modules/dashboard/core/type';
import { TableHeader } from 'modules/dashboard/styles/dashboard';

import { LessonTableBodyItem } from './LessonTableBodyItem';

const LessonTableHeader = () => {
  return (
    <TableHeader style={{ padding: '14px 16px' }}>
      <CustomHeader
        title="Name"
        styleHeader={{
          width: '100%',
          display: 'flex',
          flexGrow: 1,
          minWidth: 240,
        }}
        id="name"
      />
      <CustomHeader
        title="Schedule"
        styleHeader={{ minWidth: '500px', whiteSpace: 'normal' }}
        id="schedule"
      />
      <CustomHeader
        title="Completed"
        styleHeader={{ minWidth: '110px', whiteSpace: 'normal' }}
        id="completed"
      />
      <CustomHeader
        title="Type"
        styleHeader={{ minWidth: '109px', whiteSpace: 'normal' }}
        id="type"
      />
      <CustomHeader title="" styleHeader={{ minWidth: '100px', whiteSpace: 'normal' }} id="save" />
      <CustomHeader title="" styleHeader={{ minWidth: '32px', whiteSpace: 'normal' }} id="report" />
      <CustomHeader title="" styleHeader={{ minWidth: '36px', whiteSpace: 'normal' }} id="action" />
    </TableHeader>
  );
};

export const LessonsInClassTable: FC<{
  typeLesson: LessonType;
  lessons: Lessons[];
  handleUpdateLesson: (
    classLessonId: string,
    classScheduleId: string,
    start: string,
    end: string,
  ) => void;
  onClickAction: (
    key: 'duplicate' | 'delete' | 'export',
    classLessonId: string,
    name?: string,
  ) => void;
  goToLessonAssessmentDetailPage: (
    type: string,
    learnerId: string,
    classScheduleId: string,
    classLessonId: string,
  ) => void;
  totalLearner: number;
  handleChangeValue: (
    classLessonId: string,
    value: Date,
    startTime: string,
    endTime: string,
  ) => void;
}> = ({
  typeLesson,
  lessons,
  handleUpdateLesson,
  onClickAction,
  goToLessonAssessmentDetailPage,
  totalLearner,
  handleChangeValue,
}) => {
  return (
    <LessonTableContainer>
      <div style={{ minWidth: 'max-content' }}>
        <LessonTableHeader />
        {lessons.length ? (
          <div style={{ minWidth: '100%' }}>
            {lessons.map((item, index) => (
              <LessonTableBodyItem
                item={item}
                index={index}
                typeLesson={typeLesson}
                totalLearner={totalLearner}
                handleChangeValue={handleChangeValue}
                handleUpdateLesson={handleUpdateLesson}
                goToLessonAssessmentDetailPage={goToLessonAssessmentDetailPage}
                onClickAction={onClickAction}
              />
            ))}
          </div>
        ) : (
          <Typography style={{ textAlign: 'center', padding: '24px 0' }}>No data</Typography>
        )}
      </div>
    </LessonTableContainer>
  );
};
